import * as nativeWebviewInterface from '@ifit/native-webview-interface';
import * as actions from './state-management/action-creators';
import { refetchQueries } from './state-management/server-state/query-client';
import { store } from './state-management/store';
import { IRawAppPayload, IState } from './state-management/types';
import { callToNativeListener, callFromNativeListener } from './util/native-listeners';
import { showToast } from './util/show-toast';

nativeWebviewInterface.on('callNative', callToNativeListener);
nativeWebviewInterface.on('callJavaScript', callFromNativeListener);
nativeWebviewInterface.initNativeCalls(store, [setupApp, refreshData, viewShown]);

const validDeviceTypes = ['mobile', 'tablet'];

function setupApp(payload: IRawAppPayload, _store): void {
  if (payload.methodName !== 'setupApp') {
    return;
  }
  if (payload.refreshType === 'overnight') {
    return;
  }

  isValidSetupAppPayload(payload);

  if (_store && _store.dispatch) {
    _store.dispatch(actions.setAppState(payload));
  } else {
    showToast('store was not passed in, something went wrong');
  }
}

function refreshData(payload, _store): void {
  if (payload.methodName !== 'refreshData') {
    return;
  }
  if (payload.refreshType === 'overnight') {
    return;
  }

  if (_store && _store.dispatch) {
    const { dashboard } = _store.getState() as { dashboard: IState };
    if (!dashboard?.softwareNumber) {
      showToast('refreshData called too early, requesting initialization');
      nativeWebviewInterface.callNative({
        methodName: 'RequestInitialization',
      });
      return;
    }
  } else {
    showToast('store was not passed in, something went wrong');
  }
}

export function isValidSetupAppPayload(payload): void {
  /* istanbul ignore next */
  function propWarn(name): void {
    // eslint-disable-next-line no-prototype-builtins
    if (!payload.hasOwnProperty(name)) {
      showToast(`SetupApp expects the property "${name}" but it was not provided`);
    }
  }
  /* istanbul ignore next */
  [
    'baseGatewayAPIUrl',
    'token',
    'clientId',
    'clientSecret',
    'deviceType',
    'softwareNumber',
    'equipmentType',
    'userType',
  ].forEach(propWarn);

  if (validDeviceTypes.indexOf(payload.deviceType) < 0) {
    throw new Error(`Payload property "deviceType" must be one of the following: ${validDeviceTypes.join(', ')}`);
  }
}

function viewShown(payload: { context: 'loading' | 'ready' | 'screensaver'; methodName: string }): void {
  if (payload.methodName !== 'ViewShown') {
    return;
  }

  refetchQueries();
}

export { setupApp, refreshData, viewShown };
